export enum UserRightType {
    AddRepairs = 1,
    RemoveRepairs = 2,
    Ratings = 3,
    PublicRatings = 4,
    EditNotes = 5,
    PreferredVendors = 6,
    AdvancedOptions = 7,
    SuppressRatings = 8
}
